function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
const defaultSize = '20px';

const setWidth = ({
  size,
  width
}) => width || size || defaultSize;

const setHeight = ({
  size,
  height
}) => height || size || defaultSize;

const SVG = styled.svg.withConfig({
  displayName: "backArrow__SVG",
  componentId: "jhuc91-0"
})(["width:", ";height:", ";", ";", ";", ";polygon{fill:", ";}"], setWidth, setHeight, p => p.left && 'transform: rotate(-180deg)', p => p.up && 'transform: rotate(-90deg)', p => p.down && 'transform: rotate(90deg)', p => p.fill || 'currentColor');
export default (({
  fill,
  ...rest
}) => /*#__PURE__*/React.createElement(SVG, _extends({
  viewBox: "0 0 500 500"
}, rest, {
  fill: fill
}), /*#__PURE__*/React.createElement("polygon", {
  points: "345.606,107.5 324.394,128.713 418.787,223.107 0,223.107 0,253.107 418.787,253.107 324.394,347.5 345.606,368.713 476.213,238.106 "
})));